var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberRowSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 7.89479,
    r: 4.8,
    className: "svgText"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7158,
    cy: 7.89479,
    r: 4.8,
    className: "svgText"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.6316,
    cy: 7.89479,
    r: 4.8,
    className: "svgText"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 21.4106,
    r: 4.8,
    className: "svgText"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7158,
    cy: 21.4106,
    r: 4.8,
    className: "svgText"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7158,
    cy: 34.9264,
    r: 4.8,
    className: "svgText"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.6316,
    cy: 21.4106,
    r: 4.8,
    className: "svgText"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberRowSwitch);
export default __webpack_public_path__ + "static/media/number_row_switch.671b113e0ea8c0e33fa3441175d7c2f9.svg";
export { ForwardRef as ReactComponent };